export class EventEmitter {
    constructor() {
        this._eventCallbacks = {};
        this.skipEmission = false;
    }
    on(event, callback) {
        if (!this._eventCallbacks[event]) {
            this._eventCallbacks[event] = [];
        }
        if (this._eventCallbacks[event].indexOf(callback) === -1) {
            this._eventCallbacks[event].push(callback);
        }
        return this;
    }
    once(event, callback) {
        const temporary = (arg) => {
            if (typeof callback === 'function') {
                callback(arg);
            }
            this.off(event, temporary);
        };
        this.on(event, temporary);
        return this;
    }
    off(event, callback) {
        if (typeof event === 'undefined') {
            this.clearEvents();
            return this;
        }
        if (!callback) {
            delete this._eventCallbacks[event];
            return this;
        }
        const callbacks = this._eventCallbacks[event];
        if (callbacks === null || callbacks === void 0 ? void 0 : callbacks.length) {
            let i = callbacks.length;
            // Do this way to make sure no index is skipped when reducing size of array
            while (i-- > 0) {
                if (callbacks[i] === callback) {
                    callbacks.splice(i, 1);
                }
            }
        }
        return this;
    }
    emit(event, arg) {
        var _a;
        if (this.skipEmission) {
            return this;
        }
        // Clone array to make sure all events are fired even when reducing size of array (see this.once())
        const callbacks = (_a = this._eventCallbacks[event]) === null || _a === void 0 ? void 0 : _a.slice();
        if (callbacks) {
            for (const callback of callbacks) {
                try {
                    callback(arg);
                }
                catch (err) {
                    console.error('CallbackError: ', err);
                }
            }
        }
        return this;
    }
    clearEvents() {
        this._eventCallbacks = {};
    }
}
